// hbsfy compiled Handlebars template
var HandlebarsCompiler = require('hbsfy/runtime');
module.exports = HandlebarsCompiler.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<h3>Välkommen till Outletsverige.se!</h3>\n<p class=\"intro-welcome\">\n	Följ varumärken & bli meddelad om nya kampanjer & reor.\n</p>\n<a href=\"/setup\">\n	<button class=\"btn\" >Kom igång & följ varumärken</button>\n</a>\n<p>eller scrolla ner & shoppa på en gång &darr;</p>\n";
},"useData":true});
